module.exports = __webpack_public_path__ + "static/media/6_desktop.af818314.gif";